import { useEffect, useState } from "react";
import axios from "axios";
import { Table, Badge, Card } from "react-bootstrap";
import { FaUsers, FaCalendarDay } from "react-icons/fa";

function BasicExample() {
  const [tipoCliData, setTipoCliData] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await axios.get("./dati_dashboard.json");
        const tipoCli = res.data?.AR?.tipo_cli || [];
        const lastMinuti = res.data?.AR?.lastminuti || [];
        const today = new Date().toISOString().split("T")[0];

        const lastMinutiMap = lastMinuti.reduce((acc, item) => {
          if (item.data_ordine?.startsWith(today)) {
            const tipo = item.tipo_cliente;
            const valore = parseFloat(item.ordinato.replace(",", "."));
            acc[tipo] = (acc[tipo] || 0) + valore;
          }
          return acc;
        }, {});

        const transformedData = tipoCli.map((item) => {
          const totale = parseFloat(item.valore.replace(",", "."));
          const lastMinute = lastMinutiMap[item.tipo_cliente] || 0;
          const regular = Math.max(totale - lastMinute, 0);
          return {
            tipo_cliente: item.tipo_cliente,
            totale: totale,
            lastMinute: lastMinute,
            regular: regular,
            numero: parseInt(item.numero),
          };
        });

        setTipoCliData(transformedData.sort((a, b) => b.totale - a.totale));
      } catch (err) {
        console.error(err);
      }
    };
    fetchData();
  }, []);

 const formatToEuro = (amount) =>
    new Intl.NumberFormat("it-IT", {
      style: "currency",
      currency: "EUR",
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(amount || 0);

  return (
    <Card
      className="card bg-dark ombra ordini-ora card-home hover-effect border-0"
      style={{ borderRadius: "15px", padding: "1.2rem", paddingBottom: "0" }}
    >
      <div
        className="no-scrollbar"
        style={{
          width: "100%",
          height: 300,
          overflowY: "auto",
          overflowX: "auto", // ABILITA LO SCROLL ORIZZONTALE
          position: "relative",
          scrollbarWidth: "thin", // Per Firefox
        }}
      >
        <Table
          hover
          className="mb-0 custom-table"
          style={{
            fontSize: "0.75rem",
            width: "100%",
           // minWidth: "700px", // FORZA LA LARGHEZZA MINIMA PER EVITARE COLLASSI
            margin: 0,
            borderCollapse: "separate",
          }}
        >
          <thead className="sticky-top">
            <tr
              className="text-muted"
            >
              <th
                className="ps-3 bg-dark text-light py-3 border-0"
                style={{ width: "30%" }}
              >
                <FaUsers className="me-1" /> CATEGORIA
              </th>
              <th
                className="py-3 bg-dark fw-bold border-0 text-end"
                style={{ color: "rgba(241,111,36,1)", width: "30%" }}
              >
                VALORE
              </th>
              <th
                className="py-3 bg-dark text-light border-0 text-center pe-3"
style={{ width: "30%" }}              >
                ORDINI
              </th>
            </tr>
          </thead>

          <tbody>
            {tipoCliData.map((item, index) => (
              <tr key={index} className="align-middle">
                <td className="ps-3 fw-bold bg-dark text-light text-truncate">
                  {item.tipo_cliente}
                </td>
                <td
                  className="text-end bg-dark fw-bold"
                  style={{ color: "rgba(241,111,36,1)" }}
                >
                  {formatToEuro(item.totale)}
                </td>
                <td className="text-center bg-dark text-light pe-3">
                 
                    {item.numero}
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
      </div>

      <style>{`
        .custom-table thead th { background: white; white-space: nowrap; }
        .custom-table td { white-space: nowrap; } /* Evita che i prezzi vadano a capo */
        
        tbody tr:hover { background-color: rgba(0, 123, 255, 0.02) !important; }
        .sticky-top { top: -1px; z-index: 10; box-shadow: 0 2px 2px -1px rgba(0,0,0,0.05); }
        
        /* Scrollbar sottile */
        .table-responsive-custom::-webkit-scrollbar { height: 4px; width: 4px; }
        .table-responsive-custom::-webkit-scrollbar-thumb { background: #e0e0e0; border-radius: 10px; }
        
        .ombra { box-shadow: 0 4px 20px rgba(0,0,0,0.08); }
      `}</style>
    </Card>
  );
}

export default BasicExample;
